export default __webpack_public_path__ + "static/media/stroitel.1fb80cfa.pdf";